import { MILLISECONDS_IN_MINUTE } from '@stdlib/constants-time';
import { useQuery } from '@tanstack/react-query';

import type { HotelGalleryPictureResponse } from 'app/typings/core/admin/hotel/hotelGallery';
import { apiRequest } from 'app/utils/request/api';

import { CORE_QUERY_KEYS, ENDPOINTS } from '.';

export function useHotelGallery(id?: string | number, enabled = true) {
  const hotelId = id?.toString();

  return useQuery({
    queryKey: [CORE_QUERY_KEYS.hotelGallery, { id: hotelId }],
    queryFn: hotelId
      ? () =>
          apiRequest({
            path: ENDPOINTS.getHotelGallery,
            params: { id: hotelId },
          }) as Promise<HotelGalleryPictureResponse[]>
      : () => Promise.resolve(undefined),
    staleTime: 5 * MILLISECONDS_IN_MINUTE,
    enabled: !!hotelId && enabled,
    meta: { errorMessage: 'Error fetching Hotel gallery' },
  });
}
